import React, { useEffect, useState } from 'react';
import {
  Link,
  Redirect,
  Route,
  Switch,
  useHistory,
  useParams
} from 'react-router-dom';
import styled from 'styled-components';

import { CircularProgress, Tab, Tabs } from '@material-ui/core';

import AppSnackbar from '../../common/AppSnackbar';
import PageTemplate from '../../common/page-template/PageTemplate';
import PageTemplateDashboard from '../../common/page-template/PageTemplateDashboard';
import PageTemplateHeader, {
  PageTemplateHeaderActions
} from '../../common/page-template/PageTemplateHeader';
import PageTemplateNav from '../../common/page-template/PageTemplateNav';
import { useFindAgreement } from './Agreement.hooks';
import PublishStatusLabels from '../../common/PublishStatusLabels';
import AgreementStatusActions from './cards/AgreementStatusActions';
import AgreementTabEdit from './tabs/AgreementTabEdit';
import AgreementTabInfo from './tabs/AgreementTabInfo';

const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  .status-label-container {
    margin-top: 5px;
  }
`;

const getTabValue = (path: string) => {
  const array = path.split('/');
  return array[array.length - 1];
};

const AgreementAdminDetailPage: React.FC = () => {
  const history = useHistory();
  const { agreementId } = useParams<{ agreementId?: string }>();
  const tabValue = getTabValue(history.location.pathname);
  const { agreement: loadedAgreement, isLoading, error } = useFindAgreement(
    +(agreementId || 0),
    true
  );
  const [agreement, setAgreement] = useState(loadedAgreement);

  useEffect(() => {
    if (loadedAgreement) {
      setAgreement(loadedAgreement);
    }
  }, [loadedAgreement]);
  if (!['info', 'edit', 'assign'].includes(tabValue)) {
    // if navigating to /portal/admin/agreement/:agreementId redirect to edit tab
    return <Redirect to={`/portal/admin/agreements/${agreementId}/info`} />;
  }

  return (
    <PageTemplate>
      <PageTemplateHeader>
        {isLoading && <CircularProgress size={20} />}
        <StyledTitle>
          <h2>{agreement?.name}</h2>
          {agreement && (
            <PublishStatusLabels
              status={agreement.status}
              version={agreement.version}
            />
          )}
        </StyledTitle>
        <PageTemplateHeaderActions flex>
          {agreement && (
            <AgreementStatusActions
              agreement={agreement}
              onChange={agreement => setAgreement(agreement)}
            />
          )}
        </PageTemplateHeaderActions>
      </PageTemplateHeader>
      <PageTemplateNav>
        <Tabs
          variant='scrollable'
          indicatorColor='primary'
          scrollButtons='auto'
          value={getTabValue(history.location.pathname)}
        >
          <Tab
            component={Link}
            label='Agreement Info'
            value='info'
            to='./info'
          />
          <Tab
            component={Link}
            label='Edit Agreement'
            value='edit'
            to='./edit'
          />
          {/* <Tab
            component={Link}
            label='Assign Agreement'
            value='assign'
            to='./assign'
          /> */}
        </Tabs>
      </PageTemplateNav>
      <PageTemplateDashboard>
        <Switch>
          <Route exact path='/portal/admin/agreements/:agreementId/info'>
            {agreement && (
              <AgreementTabInfo
                agreement={agreement}
                onChange={agreement => setAgreement(agreement)}
              />
            )}
          </Route>
          <Route exact path='/portal/admin/agreements/:agreementId/edit'>
            {agreement && (
              <AgreementTabEdit
                agreement={agreement}
                onChange={agreement => setAgreement(agreement)}
              />
            )}
          </Route>
        </Switch>
      </PageTemplateDashboard>
      <AppSnackbar severity='error' open={Boolean(error)}>
        There was an error getting data from the server. Please check your
        internect connection.
      </AppSnackbar>
    </PageTemplate>
  );
};

export default AgreementAdminDetailPage;
